export default "__VITE_ASSET__DTAeLMHk__"